export function roundAmount(amount, precision = 2) {
  const isNegative = amount < 0;
  const [num, exp] = `${Math.abs(amount)}e`.split('e');
  const ret = Number(`${Math.round(Number(`${num}e${Number(exp) + precision}`))}e${Number(exp) - precision}`);
  return isNegative ? -ret : ret;
}

export function displayAmount(amount, precision = 2, prefix = '$') {
  return prefix + roundAmount(amount, precision).toFixed(precision);
}

export function roundOutPenny(amount) {
  const roundedAmount = roundAmount(amount);
  const fixedRoundedAmount = roundedAmount.toFixed(2);
  const lastDigit = Number(fixedRoundedAmount[fixedRoundedAmount.length-1]);
  const isNegative = amount < 0;
  const roundedToDimeAbs = Math.abs(Number(fixedRoundedAmount.substring(0, fixedRoundedAmount.length - 1)));
  let newAmount;
  switch (lastDigit) {
    case 1:
    case 2:
      newAmount = roundedToDimeAbs;
      break;
    case 3:
    case 4:
    case 6:
    case 7:
      newAmount = roundAmount(roundedToDimeAbs + 0.05);
      break;
    case 8:
    case 9:
      newAmount = roundAmount(roundedToDimeAbs + 0.1);
      break;
    default:
      return roundedAmount;
  }
  return isNegative ? -newAmount : newAmount;
}



// WEBPACK FOOTER //
// ./src/utils/money.js